import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const rows = [{
  label: 'Traditional vulnerability scanners',
  desc: 'Find issues, but often produce noisy lists without clear business context or verification.',
  score: 'Noisy'
}, {
  label: 'Traditional pentests',
  desc: 'Useful point-in-time insight, but quickly become stale and are expensive to repeat.',
  score: 'Stale'
}, {
  label: 'Enterprise validation platforms',
  desc: 'Powerful, but priced, packaged, and operated for mature security teams.',
  score: 'Heavy'
}, {
  label: 'Periscan',
  desc: 'Self-serve continuous validation. Realistic attack paths, AI-system risk, fix verification, shareable evidence.',
  score: 'Proof',
  active: true
}];
const winning = ['Original category insight', 'Founder-market fit', 'Self-serve onboarding', 'Fast first report', 'AI-native reasoning', 'Attack-path evidence', 'AI app validation', 'Fix verification', 'Evidence packs', 'SaaS-style pricing', 'MSSP-ready distribution', 'Modular validation expansion'];
export function Competitive() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-201">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-202">
        <SectionLabel number="18" label="Competitive" className="mb-8" data-id="element-203" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-204">
          <div className="lg:col-span-8" data-id="element-205">
            <SectionHeading size="xl" data-id="element-206">
              Not another scanner.
              <br data-id="element-207" />
              <span className="text-white/40" data-id="element-208">Not another pentest.</span>
            </SectionHeading>
          </div>
        </div>

        {/* Comparison */}
        <div className="rounded-2xl bg-[#070a0e] border border-white/5 overflow-hidden mb-20" data-id="element-209">
          <div className="px-6 py-4 border-b border-white/5 grid grid-cols-12 gap-4" data-id="element-210">
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-12 md:col-span-4" data-id="element-211">
              Category
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-12 md:col-span-6 hidden md:block" data-id="element-212">
              Approach
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-white/40 col-span-12 md:col-span-2 text-right hidden md:block" data-id="element-213">
              Signal
            </span>
          </div>
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className={`grid grid-cols-12 gap-4 px-6 py-6 border-t border-white/5 ${row.active ? 'bg-[#1a8fd4]/5' : ''}`} data-id="element-214">
              <div className="col-span-12 md:col-span-4" data-id="element-215">
                <h4 className={`text-lg font-semibold tracking-tight ${row.active ? 'text-[#1a8fd4]' : 'text-white'}`} data-id="element-216">
                  {row.label}
                </h4>
              </div>
              <div className="col-span-12 md:col-span-6" data-id="element-217">
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-218">
                  {row.desc}
                </p>
              </div>
              <div className="col-span-12 md:col-span-2 md:text-right" data-id="element-219">
                <span className={`font-mono text-xs uppercase tracking-widest ${row.active ? 'text-[#1a8fd4]' : 'text-white/40'}`} data-id="element-220">
                  {row.score}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Why Periscan wins */}
        <div data-id="element-221">
          <SectionLabel number="19" label="Why Periscan Wins" className="mb-8" data-id="element-222" />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-223">
            <div className="lg:col-span-8" data-id="element-224">
              <SectionHeading size="lg" data-id="element-225">
                The customer does not buy tools.
                <br data-id="element-226" />
                <span className="text-[#1a8fd4]" data-id="element-227">They buy confidence.</span>
              </SectionHeading>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-228">
            {winning.map((w, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.04
          }} className="px-5 py-4 rounded-xl bg-[#070a0e] border border-white/[0.06] hover:border-[#1a8fd4]/30 transition-colors" data-id="element-229">
                <span className="font-mono text-[10px] text-[#1a8fd4]/60 block mb-1" data-id="element-230">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="text-sm text-white font-medium" data-id="element-231">{w}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}